// extracted by mini-css-extract-plugin
export var title = "styles-module--title--2erkz";
export var descriptionAndSubtitle = "styles-module--descriptionAndSubtitle--1fqaF";
export var videoSize = "styles-module--videoSize--yuJg2";